import React from 'react'
import './programs.css'
import { programsData } from '../../data/programsData'
import arrow from '../../assets/rightArrow.png'
const programs = () => {
  return (
    <div className='programs' id='Programs'>
        <div className='programs-header'>
            <span className='stroke-text'>Explore Our</span>
            <span> Programs</span>
            <span className='stroke-text'>To shape you</span>
        </div>

        <div className='programs-categories'>
            {
                programsData.map((program) => {
                    return (
                        <div className='programs-category'>
                            
                                {program.image} 
                            
                            <div className='programs-category-details'>
                                <h3>{program.heading}</h3>
                                <p>{program.details}</p>
                            </div>
                            <div className='join-now'>
                                <span>Join Now</span> <img src={arrow} alt='' />
                            </div>
                        </div>
                    )
                })
            }

            

        </div>
    </div>
  )
}

export default programs